import { render } from "./CentroOrcamentario.vue?vue&type=template&id=bd0f6592&scoped=true"
import script from "./CentroOrcamentario.vue?vue&type=script&lang=js"
export * from "./CentroOrcamentario.vue?vue&type=script&lang=js"

import "./CentroOrcamentario.vue?vue&type=style&index=0&id=bd0f6592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0f6592"]])

export default __exports__